export const FETCH_EMAIL_CAMPAIGNS_REQUEST = 'FETCH_EMAIL_CAMPAIGNS_REQUEST'
export const FETCH_EMAIL_CAMPAIGNS_SUCCESS = 'FETCH_EMAIL_CAMPAIGNS_SUCCESS'
export const FETCH_EMAIL_CAMPAIGNS_FAILURE = 'FETCH_EMAIL_CAMPAIGNS_FAILURE'

export const CREATE_EMAIL_CAMPAIGN_REQUEST = 'CREATE_EMAIL_CAMPAIGN_REQUEST'
export const CREATE_EMAIL_CAMPAIGN_SUCCESS = 'CREATE_EMAIL_CAMPAIGN_SUCCESS'
export const CREATE_EMAIL_CAMPAIGN_FAILURE = 'CREATE_EMAIL_CAMPAIGN_FAILURE'

export const UPDATE_EMAIL_CAMPAIGN_REQUEST = 'UPDATE_EMAIL_CAMPAIGN_REQUEST'
export const UPDATE_EMAIL_CAMPAIGN_SUCCESS = 'UPDATE_EMAIL_CAMPAIGN_SUCCESS'
export const UPDATE_EMAIL_CAMPAIGN_FAILURE = 'UPDATE_EMAIL_CAMPAIGN_FAILURE'

export const DELETE_EMAIL_CAMPAIGN_REQUEST = 'DELETE_EMAIL_CAMPAIGN_REQUEST'
export const DELETE_EMAIL_CAMPAIGN_SUCCESS = 'DELETE_EMAIL_CAMPAIGN_SUCCESS'
export const DELETE_EMAIL_CAMPAIGN_FAILURE = 'DELETE_EMAIL_CAMPAIGN_FAILURE'

// לדוגמה: פעולה לפתיחת טופס
export const OPEN_EMAIL_CAMPAIGN_FORM = 'OPEN_EMAIL_CAMPAIGN_FORM'
export const CLOSE_EMAIL_CAMPAIGN_FORM = 'CLOSE_EMAIL_CAMPAIGN_FORM'
